<template>
  <div>
    <div v-if="!detalleEvento" class="jumbotron no_space dmbs-container">.....</div>
    <div v-if="detalleEvento" class="jumbotron no_space dmbs-container">
      <div class="container-fluid" v-if="detalleEvento">
        <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12">
          <h2>
            <b>{{ detalleEvento.Nombre }}</b>
          </h2>

          <hr />
          <p v-if="verFecha">
            <span class="font-weight-bold">{{ $t("Fechas") }}:</span>
            {{ getFecha(detalleEvento, verHora) }}
          </p>
          <p v-if="detalleEvento.Recinto">
            <span class="font-weight-bold">{{ $t("Recinto") }}:</span>
            <i>{{ detalleEvento.Recinto[0].Nombre }}</i>
          </p>
          <p v-if="detalleEvento.Poblacion">
            <span class="font-weight-bold">{{ $t("Población") }}:</span>
            <i>{{ detalleEvento.Poblacion[0].Nombre }}</i>
          </p>

          <!-- <p><strong>Dirección:</strong> <i>Arquitecte Rovira, 2, Tarragona</i></p>

        <p><strong>Población:</strong> <i>Tarragona</i></p> -->
          <hr />
          <!-- <p v-if="detalleEvento.cms.descripcion" v-html="detalleEvento.cms.descripcion"> {{detalleEvento.cms.descripcion}} </p>
        <p v-else> {{detalleEvento.cms.resumen}}</p> -->
          <div v-if="cms && cms.descripcion" v-html="descripcion"></div>
          <!-- <div v-if="contenidoIdioma">
            <p v-if="contenidoIdioma[$i18n.locale].descripcion" v-html="contenidoIdioma[$i18n.locale].descripcion">

            </p>
            <p v-else v-html="detalleEvento.cms.descripcion" ></p>
        </div> -->
          <hr />
          <!-- <pre>
          {{descripcion}}
        </pre> -->
        </div>
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 mb-0">
          <v-img
            v-if="miImagen(detalleEvento)"
            class="imagen-ficha elevation-5"
            :src="miImagen(detalleEvento)"
            :aspect-ratio="ratios[defaultImageSize]"
            max-width="254px"
          >
            <v-layout slot="placeholder" fill-height align-center justify-center ma-0>
              <v-progress-circular
                indeterminate
                :color="colorDestacado"
              ></v-progress-circular>
            </v-layout>
          </v-img>

          <!-- <v-img
          v-else-if="detalleEvento.cms.vertical"
          class="imagen-ficha elevation-5"
          :src="detalleEvento.cms.vertical"
          :aspect-ratio="ratios['vertical']"
        >
          <v-layout
            slot="placeholder"
            fill-height
            align-center
            justify-center
            ma-0
          >
            <v-progress-circular
              indeterminate
              :color="colorDestacado"
            ></v-progress-circular>
          </v-layout>
        </v-img>
        <v-img
          v-else
          class="imagen-ficha elevation-5"
          :src="sinImagen"
          :aspect-ratio="ratios['vertical']"
        >

        </v-img> -->
        </div>
      </div>
      <div id="fuera" class="container fluid mt-0" style="height: 100%; display: block">
        <iframe
          :src="iframeSrc"
          style="min-width: 100%; border: none; overflow: auto; height: 2600px;"
          frameborder="no"
          width="100%"
          scrolling="yes"
          id="iFrameResizer0"
          @load="resizeIframe"
          >Su navegador no soporta IFRAMES. Inténtelo con otro distinto.</iframe
        >
      </div>
    </div>
  </div>
</template>
<style>
iframe {
  width: 1px;
  min-width: 100%;
}
strong {
  font-weight: 600;
}
</style>

<script>
import { globales } from "../components/comunes";
import Cabecera from "@/components/plantilla/Cabecera.vue";
import Menu from "@/components/plantilla/Menu.vue";
import iFrameResize from "../assets/iframeResizer";
import axios from "axios";
import { getJmdb, getIdiomas } from "../config/servicios";

export default {
  mixins: [globales],
  props: ["cmsID", "idRecinto"],
  components: {
    Cabecera,
    Menu,
  },
  watch: {
    $route(to, form) {
      // console.log("cambio de ", to, "hacia", form, this.detalleEvento);
      this.iniciarDetalle();
    },
    eventosWeb() {
      // console.log("eventosWeb cambiado watch", this.eventoActual);
      this.iniciarDetalle();
    },
  },
  data() {
    return {
      verFecha: false,
      verHora: false,
      idiomas: {},
      cms: {},
    };
  },
  mounted() {
    // this.$store.commit('setDetalle',{})
    this.iniciarDetalle();
    // console.log("montado", this.cmsID, this.detalleEvento);

    window.scrollTo(0, 0);
  },
  computed: {
    descripcion() {
      const locale = this.$i18n.locale;

      return this.idiomas[locale]
        ? this.idiomas[locale].descripcion
        : this.detalleEvento.cms.descripcion;
    },
    queryRuta() {
      let parametros = "";

      const query = this.$route.query;
      if (query) {
        Object.keys(query).forEach(
          (clave) => (parametros += `&${clave}=${query[clave]}`)
        );
      }

      return parametros;
    },
    contenidoIdioma() {
      if (!this.detalleEvento.cms) {
        return null;
      }

      const contenidoIdioma = {};
      const idioma = this.$i18n.locale;
      const contenidoOriginal = {
        descripcion: this.detalleEvento.cms ? this.detalleEvento.cms.descripcion : "",
      };
      const contenido = {};

      contenido.es = contenidoOriginal;
      contenido[idioma] = this.idiomas[idioma];

      return contenido;
    },
    iframeSrc() {

      const lang = this.$i18n.locale;
      const Idioma = lang.toUpperCase();
      const evento = this.detalleEvento;
      if (!evento || !evento.Recinto || !evento.Recinto[0] || !evento.cmsID) {
        return "";
      }
      const idRecinto = evento.Recinto[0].Id;
      const idEvento = evento.Id;
      const contexto = evento.cmsID.split("@")[1];
      const instala = contexto ? contexto.split("_")[1] : "";
      const iframeBaseUrl = this.getIframeBaseUrl(contexto);
      const queryRuta = this.queryRuta;

      return (
        iframeBaseUrl +
        "&Idioma=" +
        Idioma +
        "&idRecinto=" +
        idRecinto +
        "&idEvento=" +
        idEvento +
        "&instala=" +
        instala +
        queryRuta
      );
    },
  },
  methods: {
    iniciarDetalle() {
      this.$store.commit("setEventoBuscador", "");
      this.$store.commit("setDetalle", {});
      this.cms = null;
      if (!this.cmsID && !this.idRecinto) {
        return;
      }

      const id = this.cmsID + "__" + this.idRecinto;

      const eventoJanto = this.$store.state.eventosJanto[id];
      // console.log("eventoJanto", eventoJanto, id, this.$store.state.eventosJanto)

      const itemWeb = this.$store.state.itemsWeb.find((evento) => {
        return evento.id == id;
      });

      try {
        this.checkJmdb({ itemWeb, eventoJanto }, 300).then((cms) => {
          return cms;
        });
      } catch (error) {
        console.log("error", error);
        this.$store.commit("setDetalle", eventoJanto);
      }
    },
    async checkJmdb({ itemWeb, eventoJanto }, time = 500) {
      if (itemWeb && itemWeb.idjmdb) {
        return new Promise((resolve, reject) => {
          setTimeout(() => {
            const datos = {
              id: itemWeb.idjmdb,
            };

            const resultado = getJmdb(datos).then((cms) => {
              console.log(" function cms", time);

              eventoJanto.cms = cms;
              this.cms = cms;

              this.$store.commit("setDetalle", eventoJanto);

              getIdiomas(datos).then((idiomas) => {
                // console.log("idiomas", idiomas);

                if (idiomas) {
                  idiomas.es = this.cms;
                  this.idiomas = idiomas;
                }
              });

              return cms;
            });

            resolve(resultado);
          }, time);
        });
      } else if (time < 3000) {
        time = time + 1000;
        console.log("time", time);
        this.checkJmdb({ itemWeb, eventoJanto }, time);
      } else {
        this.$store.commit("setDetalle", eventoJanto);
        console.log("no hay idjmdb", itemWeb);
        throw new Error("No idjmdb");
      }
    },
    resizeIframe(event) {
      const iframeActual = document.getElementById("fuera");
      // $('iframe').iFrameResize( [{log: true}] );
      var iframes = iFrameResize(
        {
          log: false, // Enable console logging
          heightCalculationMethod: "lowestElement",
        },
        "#" + event.target.id
      );
    },
    getLang() {
      let hasLang = null;
      const idioma = this.$i18n.locale;
      if (!this.detalleEvento) {
        return;
      }
      const id = this.detalleEvento.cms.id;

      const datos = {
        id,
        idioma,
      };
      //// console.log('what catos', this.detalleEvento, this.$i18n.locale)

      if (idioma != "es") {
        this.$store.dispatch("getLang", datos);
      }
    },
    getJantoData(eventoActual) {
      // console.log('EventoActual', eventoActual)
      if (eventoActual) {
        const IdCookie = eventoActual.IdCookie;
        const Contexto = eventoActual.Contexto;
        const Id = eventoActual.Id;
        axios({
          url: "https://cmspre.janto.es:8443/graphql",
          method: "post",
          data: {
            query: `
              query getEventoJanto {
                getEventoJanto(IdCookie:"${IdCookie}", Contexto:"${Contexto}", Id:"${Id}"){
                    VerHora
                    VerFecha
                  }
                }
              `,
          },
        }).then(({ data }) => {
          if (data.data.getEventoJanto) {
            const datos = data.data.getEventoJanto;

            if (datos.VerFecha == "S") {
              this.verFecha = true;
              this.detalleEvento.VerFecha = true;
            }
            if (datos.VerHora == "S") {
              this.verHora = true;
              this.detalleEvento.VerHora = true;
            }
            // console.log('verFecha',datos)
          }
        });
      }
    },
  },
};
</script>
